"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _taggedTemplateLiteral2 = require("babel-runtime/helpers/taggedTemplateLiteral");

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2; /**
                     * Copyright 2013-present, Novivia, Inc.
                     * All rights reserved.
                     */

var _templateObject = (0, _taggedTemplateLiteral3.default)(["\n                            ", "px\n                            ", "\n                            solid\n                          "], ["\n                            ", "px\n                            ", "\n                            solid\n                          "]);

var _Button = require("react-bootstrap/Button");

var _Button2 = _interopRequireDefault(_Button);

var _FormControl = require("react-bootstrap/FormControl");

var _FormControl2 = _interopRequireDefault(_FormControl);

var _InputGroup = require("react-bootstrap/InputGroup");

var _InputGroup2 = _interopRequireDefault(_InputGroup);

var _Table = require("react-bootstrap/Table");

var _Table2 = _interopRequireDefault(_Table);

var _Icon = require("react-fa/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _currency = require("currency");

var _commonTags = require("common-tags");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Table that displays the bid increments for an auction and allows to edit
 * them.
 * @class
 */
var BidIncrementsEditor = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(BidIncrementsEditor, _Component);

  function BidIncrementsEditor() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, BidIncrementsEditor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BidIncrementsEditor.__proto__ || (0, _getPrototypeOf2.default)(BidIncrementsEditor)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      // Current increments, initially loaded with the provided ones.
      increments: _this.props.increments.map(function (increment) {
        // FIXME: Remove after a deprecation cycle.
        if (increment.hasOwnProperty("jump")) {
          return increment;
        }

        console.warn("The use of 'increment' has been deprecated. Please favor 'jump'.");

        var modifiedIncrement = (0, _extends3.default)({}, increment);
        increment.jump = increment.increment;

        return modifiedIncrement;
      })
    }, _this.handleIncrementsChange = function () {
      var onIncrementsChange = _this.props.onIncrementsChange;
      var increments = _this.state.increments;

      // Send up the new increments.

      onIncrementsChange && onIncrementsChange(increments);
    }, _this.handleUpdateIncrementJump = function (index, e) {
      var increments = _this.state.increments;


      var newIncrementJump = parseFloat(e.target.value);

      if (isNaN(newIncrementJump)) {
        return;
      }

      increments[index].jump = newIncrementJump;

      // FIXME: Remove in next breaking version.
      increments[index].increment = increments[index].jump;

      _this.setState({ increments: increments }, function () {
        return _this.handleIncrementsChange();
      });
    }, _this.handleUpdateIncrementStart = function (index, e) {
      var increments = _this.state.increments;


      var newIncrementStart = parseFloat(e.target.value);

      if (isNaN(newIncrementStart)) {
        return;
      }

      increments[index].start = newIncrementStart;

      _this.setState({ increments: increments }, function () {
        return _this.handleIncrementsChange();
      });
    }, _this.handleAddIncrement = function (index) {
      var increments = _this.state.increments;


      var isLast = index === increments.length - 1;

      increments.splice(index, 0, {
        // FIXME: Remove in next breaking version.
        increment: increments[index].jump,
        jump: increments[index].jump,
        start: isLast ? increments[index].start + 0.01 : increments[index + 1].start - 0.01
      });

      _this.setState({ increments: BidIncrementsEditor.sortIncrements(increments) }, function () {
        return _this.handleIncrementsChange();
      });
    }, _this.handleRemoveIncrement = function (index) {
      var increments = _this.state.increments;

      // Technically this shouldn't happen, but better safe than sorry.

      if (increments.length <= 1) {
        return;
      }

      // If we removed the first increment, lower the second one's start point
      // to 0.
      if (index === 0) {
        increments[1].start = 0;
      }

      increments.splice(index, 1);

      _this.setState({ increments: increments }, function () {
        return _this.handleIncrementsChange();
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   * Sort the increments from the lowest "start" value to the highest.
   * @param  {array} increments Increments to sort.
   * @return {array}            Sorted increments.
   */


  (0, _createClass3.default)(BidIncrementsEditor, [{
    key: "shouldComponentUpdate",


    // We try to avoid a lot of useless rerenders when we are not editing the
    // increments.
    value: function shouldComponentUpdate(_ref2) {
      var highlightCurrentBid = _ref2.highlightCurrentBid;
      var _props = this.props,
          currentHighlightCurrentBid = _props.highlightCurrentBid,
          isReadOnly = _props.readOnly;


      if (!isReadOnly) {
        return true;
      }

      return highlightCurrentBid !== currentHighlightCurrentBid;
    }

    /**
     * Event fired when the increments are modified.
     */


    /**
     * Updates the properties of the new increment in the state based on the
     * values inputed in the fields.
     */


    /**
     * Updates the properties of the new increment in the state based on the
     * values inputed in the fields.
     */


    /**
     * Add a new increment at a specific index.
     */


    /**
     * Remove an existing increment at a specific index.
     */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var __ = this.context.__;
      var increments = this.state.increments;
      var _props2 = this.props,
          className = _props2.className,
          currencyType = _props2.currencyType,
          isReadOnly = _props2.readOnly,
          highlightCurrentBid = _props2.highlightCurrentBid;


      return _react2.default.createElement(
        "div",
        { className: "bid-increments-editor" },
        _react2.default.createElement(
          "div",
          { className: className },
          _react2.default.createElement(
            _Table2.default
            // FIXME: We have to do this otherwise there is a decade-old nasty
            // bug in Firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=332740
            ,
            { style: { borderCollapse: "separate" },
              responsive: true
            },
            _react2.default.createElement(
              "thead",
              null,
              _react2.default.createElement(
                "tr",
                null,
                _react2.default.createElement(
                  "th",
                  { colSpan: 3, width: "80%" },
                  __("general::amount_plural")
                ),
                _react2.default.createElement(
                  "th",
                  { width: "20%" },
                  __("general::increment_plural")
                )
              )
            ),
            _react2.default.createElement(
              "tbody",
              null,
              increments.reduce(function (rows, increment, index) {
                var isFirst = index === 0;
                var isLast = index === increments.length - 1;


                var highlightCurrentIncrement = isReadOnly && highlightCurrentBid >= increment.start && (isLast || highlightCurrentBid < increments[index + 1].start);

                rows.push.apply(rows, [_react2.default.createElement(
                  "tr",
                  { key: "1-" + index },
                  _react2.default.createElement(
                    "td",
                    {
                      rowSpan: 2,
                      style: {
                        borderTop: isFirst ? "inherit" : 0,
                        textAlign: "right"
                      },
                      width: isReadOnly ? "49%" : "10%"
                    },
                    isFirst ? _react2.default.createElement(
                      "strong",
                      null,
                      (0, _currency.formatMoney)(0, currencyType)
                    ) : isReadOnly ? (0, _currency.formatMoney)(increment.start, currencyType) : _react2.default.createElement(_FormControl2.default, {
                      max: !isLast ? increments[index + 1].start - 0.01 : undefined,
                      min: isFirst ? 0.01 : increments[index - 1].start + 0.01,
                      step: "0.01",
                      style: { textAlign: "right" },
                      type: "number",
                      value: increment.start,
                      onChange: function onChange(e) {
                        return _this2.handleUpdateIncrementStart(index, e);
                      }
                    })
                  ),
                  _react2.default.createElement("td", {
                    style: {
                      borderBottom: "1px black solid",
                      borderRight: isFirst ? 0 : "1px black solid",
                      borderTop: isFirst ? "inherit" : 0
                    },
                    width: "1%"
                  }),
                  _react2.default.createElement("td", {
                    rowSpan: 2,
                    style: { borderTop: isFirst ? "inherit" : 0 },
                    width: "1%"
                  }),
                  _react2.default.createElement(
                    "td",
                    {
                      className: !isReadOnly ? "text-center" : "text-left",
                      rowSpan: 2,
                      style: {
                        borderTop: isFirst ? "inherit" : 0,
                        verticalAlign: "middle"
                      },
                      width: isReadOnly ? "49%" : undefined
                    },
                    !isFirst ? _react2.default.createElement(_Icon2.default, { name: "chevron-down" }) : null
                  )
                ), _react2.default.createElement(
                  "tr",
                  { key: "2-" + index },
                  _react2.default.createElement("td", {
                    style: {
                      borderRight: "1px black solid",
                      borderTop: 0
                    }
                  })
                ), _react2.default.createElement(
                  "tr",
                  { key: "3-" + index },
                  _react2.default.createElement(
                    "td",
                    {
                      rowSpan: 2,
                      style: {
                        borderTop: 0,
                        textAlign: "right",
                        verticalAlign: "middle"
                      }
                    },
                    !isReadOnly ? _react2.default.createElement(
                      _Button2.default,
                      {
                        bsStyle: "success",
                        block: true,
                        onClick: function onClick() {
                          return _this2.handleAddIncrement(index);
                        }
                      },
                      _react2.default.createElement(_Icon2.default, { name: "plus" }),
                      " ",
                      __("increments::addHere")
                    ) : null
                  ),
                  _react2.default.createElement("td", {
                    rowSpan: 2,
                    style: {
                      borderRight: "1px black solid",
                      borderTop: 0
                    },
                    width: "1%"
                  }),
                  _react2.default.createElement("td", {
                    style: {
                      borderBottom: (0, _commonTags.oneLine)(_templateObject, highlightCurrentIncrement ? "2" : "1", highlightCurrentIncrement ? "green" : "black"),
                      borderTop: 0
                    }
                  }),
                  _react2.default.createElement(
                    "td",
                    { rowSpan: 2, style: { borderTop: 0 } },
                    isReadOnly ? _react2.default.createElement(
                      "span",
                      {
                        className: highlightCurrentIncrement ? "text-success" : "",
                        style: highlightCurrentIncrement ? { fontWeight: "bold" } : undefined
                      },
                      (0, _currency.formatMoney)(increment.jump, currencyType),
                      " ",
                      highlightCurrentIncrement ? _react2.default.createElement(_Icon2.default, { name: "arrow-left" }) : null
                    ) : _react2.default.createElement(
                      _InputGroup2.default,
                      null,
                      _react2.default.createElement(_FormControl2.default, {
                        step: "0.01",
                        type: "number",
                        value: increment.jump,
                        onChange: function onChange(e) {
                          return _this2.handleUpdateIncrementJump(index, e);
                        }
                      }),
                      !(isFirst && isLast) ? _react2.default.createElement(
                        _InputGroup2.default.Button,
                        null,
                        _react2.default.createElement(
                          _Button2.default,
                          {
                            bsStyle: "danger",
                            onClick: function onClick() {
                              return _this2.handleRemoveIncrement(index);
                            }
                          },
                          _react2.default.createElement(_Icon2.default, { name: "minus" }),
                          " ",
                          __("general::remove")
                        )
                      ) : null
                    )
                  )
                ), _react2.default.createElement(
                  "tr",
                  { key: "4-" + index },
                  _react2.default.createElement("td", { style: { borderTop: 0 } })
                )]);

                if (isLast) {
                  rows.push.apply(rows, [_react2.default.createElement(
                    "tr",
                    { key: "last-1-" + index },
                    _react2.default.createElement(
                      "td",
                      {
                        rowSpan: 2,
                        style: {
                          borderTop: 0,
                          textAlign: "right"
                        }
                      },
                      _react2.default.createElement(
                        "strong",
                        null,
                        __("general::infinity")
                      )
                    ),
                    _react2.default.createElement("td", {
                      style: {
                        borderBottom: "1px black solid",
                        borderRight: "1px black solid",
                        borderTop: 0
                      }
                    }),
                    _react2.default.createElement("td", {
                      style: {
                        borderTop: 0
                      }
                    }),
                    _react2.default.createElement("td", {
                      className: "text-center",
                      rowSpan: 2,
                      style: {
                        borderTop: 0,
                        verticalAlign: "middle"
                      }
                    })
                  ), _react2.default.createElement(
                    "tr",
                    { key: "last-2-" + index },
                    _react2.default.createElement("td", {
                      style: {
                        borderRight: 0,
                        borderTop: 0
                      }
                    }),
                    _react2.default.createElement("td", {
                      style: {
                        borderLeft: 0,
                        borderTop: 0
                      }
                    })
                  )]);
                }

                return rows;
              }, [])
            )
          )
        )
      );
    }
  }]);
  return BidIncrementsEditor;
}(_react.Component), _class.propTypes = {
  className: _propTypes2.default.string,

  // Currency in which the increments are provided.
  currencyType: _propTypes2.default.string.isRequired,

  // Amount of the current bid, provided to highlight its bracket.
  highlightCurrentBid: _propTypes2.default.number,

  // Different levels of increments.
  increments: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    // FIXME: This one really should be called jump.
    increment: _propTypes2.default.number,

    jump: _propTypes2.default.number.isRequired,

    start: _propTypes2.default.number.isRequired
  }).isRequired).isRequired,

  // If set, disables all editing functionality.
  readOnly: _propTypes2.default.bool,

  // Event fired when the increments are modified.
  onIncrementsChange: _propTypes2.default.func
}, _class.contextTypes = {
  // Translation utility.
  __: _propTypes2.default.func.isRequired
}, _class.sortIncrements = function (increments) {
  return increments.sort(function (increment1, increment2) {
    return increment1.start - increment2.start;
  });
}, _temp2);
exports.default = BidIncrementsEditor;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/react-components/BidIncrementsEditor.jsx
// module id = 477
// module chunks = 15 19 33